import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { SearchableSelect } from "@/components/SearchableSelect";

export function MunicipalitySelect({ value, onChange, testId }) {
  const [list, setList] = useState([]);
  const v = value || {};

  useEffect(() => {
    api.get("/municipalities").then(({ data }) => setList(data)).catch(() => {});
  }, []);

  const districts = [...new Set(list.map((m) => m.district))]
    .sort((a, b) => a.localeCompare(b))
    .map((d) => ({ label: d, value: d }));
  const munis = list
    .filter((m) => m.district === v.district)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((m) => ({ label: m.name, value: m.name }));

  const onDistrict = (d) => onChange({ district: d, name: "", type: "" });
  const onMuni = (name) => {
    const m = list.find((x) => x.district === v.district && x.name === name);
    onChange({ district: v.district, name, type: m ? m.mtype : "" });
  };

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium text-slate-800">Municipality <span className="text-red-500">*</span></Label>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-1.5">
          <Label className="text-xs text-slate-500">District</Label>
          <SearchableSelect value={v.district || ""} onChange={onDistrict} options={districts} placeholder="Select district" testId={`${testId}-district`} />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs text-slate-500">Municipal Name</Label>
          <SearchableSelect value={v.name || ""} onChange={onMuni} options={munis} placeholder={v.district ? "Select municipality" : "Select district first"} disabled={!v.district} testId={`${testId}-name`} />
        </div>
        <div className="space-y-1.5">
          <Label className="text-xs text-slate-500">Municipal Type</Label>
          <Input className="h-12 bg-slate-50 text-slate-700" value={v.type || ""} readOnly placeholder="Auto-filled" data-testid={`${testId}-type`} />
        </div>
      </div>
    </div>
  );
}
